import React from 'react'
import './Food.css'
import { Link } from 'react-router-dom'
import foodItem from '../images/foodItem-my-res.png'
import { useDispatch, useSelector } from 'react-redux'
import { biryaniDecrease, biryaniIncrease, friedRiceDecrease, friedRiceIncrease, grillChickenDecrease, grillChickenIncrease, northMealsDecrease, northMealsIncrease, southMealsDecrease, southMealsIncrease, tandooriChickenDecrease, tandooriChickenIncrease, vegBiryaniDecrease, vegBiryaniIncrease } from '../redux/food/foodActions'
import Order from './Order'

const Food = () => {
    const dispatch = useDispatch()
    const biryani = useSelector(state => state.food.biryani)
    const biryaniPrice = useSelector(state => state.food.biryaniPrice)
    const friedRice = useSelector(state => state.food.friedRice)
    const friedRicePrice = useSelector(state => state.food.friedRicePrice)
    const vegBiryani = useSelector(state => state.food.vegBiryani)
    const vegBiryaniPrice = useSelector(state => state.food.vegBiryaniPrice)
    const southMeals = useSelector(state => state.food.southMeals)
    const southMealsPrice = useSelector(state => state.food.southMealsPrice)
    const northMeals = useSelector(state => state.food.northMeals)
    const northMealsPrice = useSelector(state => state.food.northMealsPrice)
    const tandooriChicken = useSelector(state => state.food.tandooriChicken)
    const tandooriChickenPrice = useSelector(state => state.food.tandooriChickenPrice)
    const grillChicken = useSelector(state => state.food.grillChicken)
    const grillChickenPrice = useSelector(state => state.food.grillChickenPrice)
    
  return (
    <div className='food'>
        <ul className='foodContainer'>
            <li className="foodItem">
                <button onClick={() => dispatch(biryaniIncrease())}>+</button>
                <p className='foodItemName'>Biryani - &#8377;250</p>
                <button onClick={() => {if(biryani>0) dispatch(biryaniDecrease())}}>-</button>
                <p className='foodItemPrice'>{biryani} &#8377;{biryaniPrice}</p>
            </li>
            <li className="foodItem">
                <button onClick={() => dispatch(friedRiceIncrease())}>+</button>
                <p className='foodItemName'>Fried Rice - &#8377;85</p>
                <button onClick={() => {if(friedRice>0) dispatch(friedRiceDecrease())}}>-</button>
                <p className='foodItemPrice'>{friedRice} &#8377;{friedRicePrice}</p>
            </li>
            <li className="foodItem">
                <button onClick={() => dispatch(vegBiryaniIncrease())}>+</button>
                <p className='foodItemName'>Veg Biryani - &#8377;125</p>
                <button onClick={() => {if(vegBiryani>0) dispatch(vegBiryaniDecrease())}}>-</button>
                <p className='foodItemPrice'>{vegBiryani} &#8377;{vegBiryaniPrice}</p>
            </li>
            <li className="foodItem">
                <button onClick={() => dispatch(southMealsIncrease())}>+</button>
                <p className='foodItemName'>South Indian Meals - &#8377;100</p>
                <button onClick={() => {if(southMeals>0) dispatch(southMealsDecrease())}}>-</button>
                <p className='foodItemPrice'>{southMeals} &#8377;{southMealsPrice}</p>
            </li>
            <li className="foodItem">
                <button onClick={() => dispatch(northMealsIncrease())}>+</button>
                <p className='foodItemName'>North Indian Meals - &#8377;150</p>
                <button onClick={() => {if(northMeals>0) dispatch(northMealsDecrease())}}>-</button>
                <p className='foodItemPrice'>{northMeals} &#8377;{northMealsPrice}</p>
            </li>
            <li className="foodItem">
                <button onClick={() => dispatch(tandooriChickenIncrease())}>+</button>
                <p className='foodItemName'>Tandoori Chicken - &#8377;300</p>
                <button onClick={() => {if(tandooriChicken>0) dispatch(tandooriChickenDecrease())}}>-</button>
                <p className='foodItemPrice'>{tandooriChicken} &#8377;{tandooriChickenPrice}</p>
            </li>
            <li className="foodItem">
                <button onClick={() => dispatch(grillChickenIncrease())}>+</button>
                <p className='foodItemName'>Grill Chicken - &#8377;300</p>
                <button onClick={() => {if(grillChicken>0) dispatch(grillChickenDecrease())}}>-</button>
                <p className='foodItemPrice'>{grillChicken} &#8377;{grillChickenPrice}</p>
            </li>
        </ul>
        <div className="foodButtons">
            <Link to={'/snacks'}><button className='btn_text btn3'>Snacks</button></Link>
            <img src={foodItem} alt="food Item..." />
            <Link to={'/drinks'}><button className='btn_text btn2'>Beverages</button></Link>
        </div>
        <Order />
    </div>
  )
}

export default Food